import React, { useContext } from 'react'
import { FormDataAdsInfoContext, ShowAdsInfoContext, modalType } from '../types'
import { InputElement } from '../../../HtmlComponents/InputElement'
import { useTranslation } from 'react-i18next'
import { InputImages } from '../../../HtmlComponents/InputImages'

const InputsAdsInfo = () => {
  const {
    title, setTitle,
    company, setCompany,
    finishDate, setFinishDate,
    images, setImages,

  } = useContext(FormDataAdsInfoContext)

  const { t } = useTranslation()

  const { selectedModal } = useContext(ShowAdsInfoContext)

  return (
    <>
      <InputElement name={t("titre")} value={title} setValue={setTitle}/>
      <InputElement name={t("Societe")} value={company} setValue={setCompany}/>
      <InputElement type='date' name={t("Date de fin")} value={finishDate} setValue={setFinishDate}/>
      {selectedModal === modalType.AddModal && 
        <InputImages name="photos" setImages={setImages} accept="image/*" />      
      }
      <div className="grid grid-cols-4 gap-2">
        {images?.length > 0 && selectedModal === modalType.AddModal && 
          images.map((img: any, index: number) => (
            <img
              className="w-32 h-32"
              key={index}
              src={URL.createObjectURL(img)}
              alt={`${index + 1}`}
            />
          ))}
      </div>
    </>
  )
}

export default InputsAdsInfo